<template>
    <VJoyHighlight class="experiences-linkedin-highlight" level="info" display-icon icon="linkedin" data-testid="experiences-linkedin-highlight">
        <template #highlight-title>
            <VJoyWrapper justify="space-between" align="center" no-margin wrap="nowrap">
                <div>
                    {{ title }}
                    <br />
                    <span class="experiences-linkedin-highlight__description">
                        {{ description }}
                    </span>
                </div>
                <VJoyLink type="button" class="experiences-linkedin-highlight__link" @click="openResumeImport">
                    {{ t('profile.section.experiences.linkedin.highlight.cta') }}
                </VJoyLink>
            </VJoyWrapper>
        </template>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {computed, useTranslation} from '#imports';
    import {VJoyHighlight, VJoyLink, VJoyWrapper} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';

    const props = withDefaults(defineProps<{stale?: boolean}>(), {stale: false});

    const {t} = useTranslation();

    const title = computed(() =>
        props.stale ? t('profile.section.experiences.linkedin.highlight.stale.title') : t('profile.section.experiences.linkedin.highlight.title'),
    );
    const description = computed(() =>
        props.stale
            ? t('profile.section.experiences.linkedin.highlight.stale.description')
            : t('profile.section.experiences.linkedin.highlight.description'),
    );

    function openResumeImport() {
        eventBus.emit('experiences:resume-import-mode', {entryPoint: EditionOpenedEntryPoint.LINKEDIN_IMPORT_CTA});
    }
</script>

<style lang="scss">
    .experiences-linkedin-highlight {
        &__description {
            font-weight: var(--joy-font-weight-normal);
        }
        &__link {
            font-weight: var(--joy-font-weight-bold);
            white-space: nowrap;
        }

        @media screen and (max-width: 600px) {
            .joy-wrapper {
                flex-wrap: wrap;
            }
            &__link {
                white-space: normal;
            }
        }
    }
</style>
